export default __webpack_public_path__ + "static/blog-bg-2227f8e80931cdb12ddbc5d35051ec2d.png";